import React from 'react';
import { portfolioData } from '../mock';
import { Mail, Phone, Linkedin, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {/* Left: Brand & Description */}
          <div>
            <h3 className="text-3xl font-black tracking-tighter text-white mb-4">
              SLOOMX
            </h3>
            <p className="text-zinc-500 leading-relaxed max-w-md">
              Creating cinematic experiences through video editing and storytelling. 
              Transforming visions into visual reality.
            </p>
          </div>

          {/* Right: Contact Links */}
          <div className="flex flex-col gap-4">
            <a
              href={`mailto:${portfolioData.email}`}
              className="group flex items-center justify-between text-zinc-400 hover:text-white transition-colors py-2 border-b border-zinc-900 hover:border-zinc-700"
            >
              <span className="text-sm uppercase tracking-wider">Email</span>
              <ArrowUpRight className="h-4 w-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
            <a
              href={`tel:${portfolioData.phone}`}
              className="group flex items-center justify-between text-zinc-400 hover:text-white transition-colors py-2 border-b border-zinc-900 hover:border-zinc-700"
            >
              <span className="text-sm uppercase tracking-wider">Phone</span>
              <ArrowUpRight className="h-4 w-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
            <a
              href={portfolioData.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-between text-zinc-400 hover:text-white transition-colors py-2 border-b border-zinc-900 hover:border-zinc-700"
            >
              <span className="text-sm uppercase tracking-wider">LinkedIn</span>
              <ArrowUpRight className="h-4 w-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-zinc-600">
          <p>
            © {currentYear} Sloomx. All rights reserved.
          </p>
          <p className="uppercase tracking-wider">
            Video Editor & Designer
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
